import { render } from "./ScatterChart.vue?vue&type=template&id=b9718bb4"
import script from "./ScatterChart.vue?vue&type=script&lang=js"
export * from "./ScatterChart.vue?vue&type=script&lang=js"

import "./ScatterChart.vue?vue&type=style&index=0&id=b9718bb4&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__